module.exports = __webpack_public_path__ + "img/bottom_hk2.49f4fe58.png";